import React, {useEffect, useState} from 'react';
import * as CandidateService from '@app/services/CandidateService';
import {toast} from 'react-toastify';
import '../styles.css';
import {cloneDeep} from 'lodash';
import Select from 'react-select';
import {AREA_OPTIONS, Provinces} from '@app/constants/Provinces';
import * as ValidateUtils from '@app/utils/ValidationUtils';
import {autoCorrectStrPhone} from '@app/utils/ValidationUtils';
import {
    CALLER_NAMES,
    CANDIDATE_CATEGORY_FIELDS, CANDIDATE_INPUT_INFO_TYPES,
    CANDIDATE_ORIGINS, CANDIDATE_ORIGINS_OPTIONS,
    EMAIL_FILED_NAME,
    ENGAGEMENT_STATUS,
    ExtractType, GENDERS,
    IMPORT_EXCEL_CONTACT_FIELDS,
    INDUSTRY_FUNCTIONS,
    LATEST_STABLE_LEVELS,
    LOCAL_STORAGE_USER_LOGIN_INFO, ME_LIST_INPUT,
    OBJECT_SPECIALS, PersonTypeOptions,
    PHONE_FILED_NAME,
    ResponseCode
} from '@app/constants/Common';
import {
    appendOptions, arrayIncludeItem,
    arrayToLowerCase,
    arrayToString, capitalizeName,
    checkEmailToSendInOtherEmails,
    compareArrays,
    compareOptions,
    compareString,
    getGenderByCallerName,
    monthOptions, nameCamelize,
    optionsToArray,
    optionsToString,
    stringToArray, stringToLowerCase, stringToOption,
    twoArrayHaveSameElement,
    yearOptions
} from '@app/utils/CommonUtils';
import {Link} from 'react-router-dom';
import ReactChipInput from 'react-chip-input';
import CandidateFlows from "@pages/candidate/userinput/component/CandidateFlows";
import {standardPrefixPhones} from "@app/utils/PhoneUtils";
import {concatStrings} from "@app/utils/StringUtils";
import {alertMessage, Messages, showMessage} from "@app/constants/Messages";
import {camelCase} from "lodash/string";
import {searchAllInputInfo} from "@app/services/CandidateService";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import {checkExistsCommonFieldValues, confirmSubmitNotesWhenInputInPriorityTimeRange} from "@app/utils/CandidateUtils";
import * as CandidateUtils from "@app/utils/CandidateUtils";
import {COUNTRIES, CANDIDATE_NATIONALITIES, checkNationalOptionsHaveExpatAndVN} from "@app/constants/Nationality";
import CandidateLanguageComponent from "@pages/candidate/commonview/language/CandidateLanguageComponent";
import {CandidateDetailLanguageMode} from "@app/constants/Tabs";

const ProcessUploadExcelResult = (props) => {
    const [candidates, setCandidates] = useState([]);
    const [extractCandidates, setExtractCandidates] = useState([]);
    const [checkingExistsLoading, setCheckingExistsLoading] = useState(false);
    const [currCandidate, setCurrCandidate] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [provinceOptions, setProvinceOptions] = useState([]);
    const [workYears, setWorkYears] = useState([]);
    const [workMonths, setWorkMonths] = useState([]);
    const [showContent, setShowContent] = useState(false);
    const [createCandidateFormInputSuccess, setCreateCandidateFormInputSuccess] = useState(false);
    const [inputCommonData, setInputCommonData] = useState({
        common_industry: '',
        common_function: '',
        common_origin: '',
        common_origin_note: '',
        common_general_note: '',
        hasSaveInputCommon: false
    });
    const [showCommonInputModal, setShowCommonInputModal] = useState(false);
    const [btnInputCommonData, setBtnInputCommonData] = useState(false);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const {candidateList} = props
    const {hasInputCommon} = props
    const {isShow} = props
    useEffect(() => {
        if (hasInputCommon && btnInputCommonData && !showCommonInputModal && candidates.length > 0) {
            setShowCommonInputModal(true);
            btnInputCommonData.click();
        }

        if (provinceOptions.length === 0) {
            let provinces = [];
            Provinces.forEach(item => {
                provinces.push({
                    value: item,
                    label: item.charAt(0).toUpperCase() + item.slice(1)
                });
            });
            setProvinceOptions(provinces);
        }

        if (workYears.length === 0) {
            setWorkYears(yearOptions());
        }

        if (workMonths.length === 0) {
            setWorkMonths(monthOptions());
        }

    }, []);

    useEffect(() => {
        setExtractCandidates(cloneDeep(candidateList));
        setCandidates(cloneDeep(candidateList));
        if (!currCandidate && candidateList.length > 0) {
            setCurrentIndex(0)
            setCurrCandidate(cloneDeep(candidateList[0]));
        }
    }, [candidateList]);

    useEffect(() => {
        setShowContent(isShow)
    }, [isShow]);

    useEffect(async () => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const PROCESS_FIELDS = ['full_name', 'last_name', 'vn_name', 'foreign_name',
        'email_name', 'email', 'phone', 'gender', 'vocative',
        'caller_name_to_email', 'local_province', 'local_area', 'local_province_email', 'local_area_email',
        'industry', 'industry_segment1', 'industry_segment2', 'function', 'function_segment1', 'function_segment2', 'industry_function', 'latest_stable_level'];

    const openNewTab = async (url) => {
        if (url.indexOf('https') === -1) {
            url = `https://${url}`;
            window.open(url, '_blank').focus();
        }
        return false;
    };

    const onRemoveCandidate = () => {
        let canList = cloneDeep(candidates);
        canList.splice(currentIndex, 1);
        setCandidates(canList);
        if (currentIndex > canList.length - 1) {
            setCurrentIndex(canList.length - 1);
            setCurrCandidate(canList[canList.length - 1]);
        } else {
            setCurrCandidate(canList[currentIndex]);
        }
    };

    const validateInputEmail = (emails) => {
        if (emails && !ValidateUtils.validateEmailString(emails, ';')) {
            alert('Email nhập không hợp lệ!');
            return false;
        }
        return true;
    };

    const validateInputPhone = (phone) => {
        if (phone && !ValidateUtils.validatePhoneString(phone, ';')) {
            alert('Số điện thoại nhập không hợp lệ!');
            return false;
        }
        return true;
    };

    const onCandidateNext = () => {
        // Validate email
        let strEmails = concatStrings(arrayToString(currCandidate.email), arrayToString(currCandidate.ever_email))
        strEmails = concatStrings(strEmails, arrayToString(currCandidate.block_email))
        if (!validateInputEmail(strEmails)) {
            return;
        }

        // Validate phone
        if (!validateInputPhone(currCandidate.phone)) {
            return;
        }
        let nextIndex = currentIndex + 1;
        setCurrentIndex(nextIndex);
        setCurrCandidate(cloneDeep(candidates[nextIndex]));
    };


    const onCandidateBack = () => {
        // Validate email
        let strEmails = concatStrings(arrayToString(currCandidate.email), arrayToString(currCandidate.ever_email))
        strEmails = concatStrings(strEmails, arrayToString(currCandidate.block_email))
        if (!validateInputEmail(strEmails)) {
            return;
        }

        // Validate phone
        if (!validateInputPhone(currCandidate.phone)) {
            return;
        }
        let nextIndex = currentIndex - 1;
        setCurrentIndex(nextIndex);
        setCurrCandidate(cloneDeep(candidates[nextIndex]));
    };

    const onChangeLocalProvince = (values) => {
        candidates[currentIndex]['local_province'] = values;
        currCandidate['local_province'] = values;
        candidates[currentIndex]['local_province_email'] = values;
        currCandidate['local_province_email'] = values;
        setCandidates(cloneDeep(candidates));
    };

    const onChangeLocalNationality = (values) => {
        if (checkNationalOptionsHaveExpatAndVN(values)) {
            showMessage(Messages.cannotNationalExpatAndVN)
            return;
        }
        candidates[currentIndex]['local_nationality'] = values;
        currCandidate['local_nationality'] = values;
        setCandidates(cloneDeep(candidates));
    };

    const onChangeLocalEverWorkNationality = (values) => {
        candidates[currentIndex]['local_ever_work_nationality'] = values;
        currCandidate['local_ever_work_nationality'] = values;
        setCandidates(cloneDeep(candidates));
    };

    const onChangeLocalProvinceEmail = (values) => {
        candidates[currentIndex]['local_province_email'] = values;
        currCandidate['local_province_email'] = values;
        setCandidates(cloneDeep(candidates));
    };

    const onChangeLocalArea = (values) => {
        candidates[currentIndex]['local_area'] = values;
        currCandidate['local_area'] = values;
        candidates[currentIndex]['local_area_email'] = values;
        currCandidate['local_area_email'] = values;
        setCandidates(cloneDeep(candidates));
    };

    const onChangeLocalAreaEmail = (values) => {
        candidates[currentIndex]['local_area_email'] = values;
        currCandidate['local_area_email'] = values;
        setCandidates(cloneDeep(candidates));
    };

    const onRemoveSpace = (fieldName, careerIndex) => {
        if (['email', 'phone', 'full_name', 'origin_company', 'title'].includes(fieldName)) {
            // Trường hợp là các field trong career summaries
            if (careerIndex !== undefined && careerIndex !== "") {
                let fieldValue = currCandidate.career_summaries[careerIndex][fieldName]
                if (fieldValue) {
                    fieldValue = fieldValue.replaceAll(" ", "")
                    currCandidate.career_summaries[careerIndex][fieldName] = fieldValue;
                    setCurrCandidate({...currCandidate});
                    candidates[currentIndex].career_summaries = currCandidate.career_summaries;
                }
            } else {
                let fieldValue = currCandidate[fieldName]
                if (fieldValue) {
                    fieldValue = fieldValue.replaceAll(" ", "")
                    currCandidate[fieldName] = fieldValue
                    candidates[currentIndex][fieldName] = fieldValue;
                    setCurrCandidate({...currCandidate})
                }
            }
        }
    };

    const onChangeInput = (event, fieldKey) => {
        console.log('onChangeInput');
        if (fieldKey === 'industry_function' || fieldKey === 'engagement_status' || fieldKey === 'origin') {
            candidates[currentIndex][fieldKey] = event;
            currCandidate[fieldKey] = event;
            setCurrCandidate({...currCandidate})
            return;
        }

        let fieldName = event.target.name;
        let fieldValue = event.target.value;
        candidates[currentIndex][fieldName] = fieldValue;
        // if (fieldName === 'gender') {
        //     //
        //     if (fieldValue === 'Nam') {
        //         candidates[currentIndex]['caller_name_to_email'] = 'anh';
        //         currCandidate['caller_name_to_email'] = 'anh';
        //     } else if (fieldValue === 'Nữ') {
        //         candidates[currentIndex]['caller_name_to_email'] = 'chị';
        //         currCandidate['caller_name_to_email'] = 'chị';
        //     } else {
        //         candidates[currentIndex]['caller_name_to_email'] = '';
        //         currCandidate['caller_name_to_email'] = '';
        //     }
        // }
        if (fieldName === 'caller_name_to_email') {
            const gender = getGenderByCallerName(fieldValue)
            candidates[currentIndex]['gender'] = gender;
            currCandidate['gender'] = gender;
        }
        else if (fieldName === 'email_name') {
            if (fieldValue) {
                candidates[currentIndex]['vn_name'] = fieldValue;
                currCandidate['vn_name'] = fieldValue;
            }
            // else {
            //     candidates[currentIndex]['email_name'] = currCandidate['foreign_name'];
            //     currCandidate['email_name'] = currCandidate['foreign_name'];
            // }
        }
        // else if (fieldName === 'foreign_name') {
        //     if (!currCandidate['vn_name']) {
        //         candidates[currentIndex]['email_name'] = fieldValue;
        //         currCandidate['email_name'] = fieldValue;
        //     }
        // }

        else if (fieldName === 'local_province') {
            candidates[currentIndex]['local_province_email'] = fieldValue;
            currCandidate['local_province_email'] = fieldValue;
        } else if (fieldName === 'local_area') {
            candidates[currentIndex]['local_area_email'] = fieldValue;
            currCandidate['local_area_email'] = fieldValue;
        } else if (fieldName === 'phone') {
            fieldValue = autoCorrectStrPhone(fieldValue, ";")
            fieldValue = standardPrefixPhones(fieldValue)
            candidates[currentIndex][fieldName] = fieldValue;
            currCandidate[fieldName] = fieldValue;
        } else if (fieldName === 'email' || fieldName === 'ever_email' || fieldName === 'block_email') {
            fieldValue = fieldValue.replaceAll(" ", "")
            candidates[currentIndex][fieldName] = fieldValue;
            currCandidate[fieldName] = fieldValue;
        }

        setCandidates(cloneDeep(candidates));
        currCandidate[fieldName] = fieldValue;
        setCurrCandidate(cloneDeep(currCandidate));
    };

    const onAddIndustryFunctionItem = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(currCandidate[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            currCandidate[fieldName] = arr
            candidates[currentIndex][fieldName] = arr;
            setCurrCandidate({...currCandidate})
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }

    const onRemoveIndustryFunctionItem = (index, fieldName) => {
        let arr = cloneDeep(currCandidate[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            currCandidate[fieldName] = arr
            candidates[currentIndex][fieldName] = arr;
            setCurrCandidate({...currCandidate})
        }
    }

    const onChangeIndustryFunctionItem = (event, fieldName) => {
        if (fieldName === 'industry_function') {
            currCandidate[fieldName] = event
            candidates[currentIndex][fieldName] = event;
        } else {
            currCandidate[event.target.name] = event.target.value
            candidates[currentIndex][event.target.name] = event.target.value;
        }
        setCurrCandidate({...currCandidate})
    }

    const onAddCareerSummary = (event) => {
        console.log('onAddCareerSummary');
        if (!currCandidate.career_summaries) {
            currCandidate.career_summaries = []
        }

        if (currCandidate.career_summaries.length > 0) {
            let latestRow = currCandidate.career_summaries[currCandidate.career_summaries.length - 1]

            let rowIsBlank = true
            Object.keys(latestRow).forEach(key => {
                if (key !== 'displayed_flag' && latestRow[key] && key !== 'created_user' && latestRow[key]) {
                    rowIsBlank = false
                }
            })

            if (rowIsBlank) {
                alert("Tồn tại record career summary chưa được nhập thông tin.")
                return;
            }
        }

        currCandidate.career_summaries.push({
            work_start_year: '',
            work_start_month: '',
            work_end_year: '',
            work_end_month: '',
            origin_company: '',
            title: '',
            company_note: '',
            note_of_period: '',
            displayed_flag: currCandidate.career_summaries.length === 0,
            created_user: userLoginInfo.id
        });

        setCurrCandidate({...currCandidate});
    };
    const onSortCareerSummary = () => {
        if (!currCandidate.career_summaries) {
            return;
        }
        currCandidate.career_summaries.sort(function (a, b) {
            if (a.work_start_year.value < b.work_start_year.value) {
                return 1;
            }
            if (a.work_start_year.value > b.work_start_year.value) {
                return -1;
            }

            if (a.work_start_month.value < b.work_start_month.value) {
                return 1;
            }
            if (a.work_start_month.value > b.work_start_month.value) {
                return -1;
            }
            return 0;
        });

        setCurrCandidate({...currCandidate});
    };
    const onDeleteCareerSummary = (index) => {
        if (currCandidate.career_summaries.length === 1) {
            currCandidate.career_summaries = [];
        } else {
            currCandidate.career_summaries.splice(index, 1);
        }

        setCurrCandidate({...currCandidate});
        candidates[currentIndex].career_summaries = currCandidate.career_summaries;
    };
    const onChangeCareerInput = (event, index) => {
        console.log('onChangeCommonInput');
        let fieldName = event.target.name
        if (fieldName === 'displayed_flag') {
            currCandidate.career_summaries.map(item => {
                item.displayed_flag = false
                return item;
            })
            currCandidate.career_summaries[index]["displayed_flag"] = true
        } else {
            currCandidate.career_summaries[index][fieldName] = event.target.value;
        }

        setCurrCandidate({...currCandidate});
        candidates[currentIndex].career_summaries = currCandidate.career_summaries;
    };
    const onChangeWorkTime = (index, value, fieldName) => {
        console.log('onChangeWorkTime');
        // Validate require end time >= start time
        let currentRow = currCandidate.career_summaries[index];
        let oldValue = currentRow[fieldName];
        //set new value temp
        currentRow[fieldName] = value;
        if (currentRow.work_start_year.value && currentRow.work_end_year.value && currentRow.work_start_year.value > currentRow.work_end_year.value
            || (currentRow.work_start_year.value === currentRow.work_end_year.value
                && currentRow.work_start_month.value > currentRow.work_end_month.value)) {
            currentRow[fieldName] = oldValue;
            alert('Time kết thúc phải sau Time bắt đầu.');
            return;
        }
        currCandidate.career_summaries[index][fieldName] = value;
        setCurrCandidate({...currCandidate});
        candidates[currentIndex].career_summaries = currCandidate.career_summaries;
    };

    const onUpdateExtractResult = async (candidate, fields) => {
        // in case save all
        if (!fields) {
            // Validate email
            if (!validateInputEmail(currCandidate.email)) {
                return;
            }

            // Validate phone
            if (!validateInputPhone(currCandidate.phone)) {
                return;
            }
        }

        //
        // if (currCandidate.require_email && !currCandidate.email) {
        //     alert(`Vui lòng nhập email.`);
        //     return;
        // }
        //
        // if (currCandidate.require_phone && !currCandidate.phone) {
        //     alert(`Vui lòng nhập số điện thoại.`);
        //     return;
        // }

        const emailToSendInOtherEmails = twoArrayHaveSameElement(currCandidate.email_to_send,
            [
                // ...currCandidate.db_candidate_info.email,
                // ...currCandidate.db_candidate_info.email_to_send,
                ...currCandidate.db_candidate_info.rarely_email,
                ...currCandidate.db_candidate_info.ever_email,
                ...currCandidate.db_candidate_info.block_email,
            ])

        if (emailToSendInOtherEmails) {
            toast.error(Messages.emailToSendInErrorBlockEmails)
            alert(Messages.emailToSendInErrorBlockEmails)
            return;
        }

        candidate.fields = [];
        if (fields) {
            candidate.fields = fields;
        }

        if (!candidate.savedFields) {
            candidate.savedFields = [];
        }

        // Show dialog confirm nếu nhập trường email không phải là email cá nhân.
        if (candidate.fields.includes("email")) {
            // Check standard personal emails. Nếu user xác nhận ok sẽ tiếp tục xử lý tiếp theo.
            const confirm = await CandidateUtils.processWithoutPersonalEmail(stringToArray(currCandidate.email))
            if (!confirm) {
                return;
            }
        }

        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        if (checkExistsCommonFieldValues(candidate, userLoginInfo.id)
            || checkExistsCommonFieldValues(candidate.languages, userLoginInfo.id)) {
            return;
        }

        let payload = candidate

        // Truong hop update 1 hoặc nhiều fields
        if (fields && fields.length > 0) {
            payload = {id: candidate.id}
            fields.forEach(f => {
                payload[f] = candidate[f]
            })
        }

        // candidate.fields.forEach(field => {
        //     if (!candidate.savedFields.includes(field)) {
        //         candidate.savedFields.push(field);
        //     }
        // });

        payload.extract_type = ExtractType.IMPORT_EXCEL
        setCreateCandidateFormInputSuccess(false)

        CandidateService.saveCandidateNewInput(payload)
            .then((res) => {
                if (res.sts_code === ResponseCode.SUCCESS) {
                    toast.success(Messages.saveInfoSuccess)
                } else if (res.sts_code === ResponseCode.EXISTS_GREATER_TWO_SAME_CV) {
                    toast.error(Messages.existsTwoOtherPersonsUsePhoneEmail);
                } else if (res.sts_code === ResponseCode.HAVE_DIFF_FIELD_ONE_VALUE) {
                    toast.warning(Messages.otherUserInputDiffValueOfFieldOne);
                    alert(Messages.otherUserInputDiffValueOfFieldOne);
                } else if (res.sts_code === ResponseCode.PHONE_EMAIL_USED_BY_OTHER_USER) {
                    toast.error(res.message);
                    alert(res.message);
                } else {
                    alertMessage(res.sts_code, true, true)
                }
            })
            .catch((error) => {
                // toast.error(`Lưu thông tin thất bại.`);
                console.log(`Error:${JSON.stringify(error)}`);
            });
    };

    const onSaveCareerSummary = async () => {
        onSortCareerSummary()
        await onUpdateExtractResult(currCandidate, ['career_summaries'])
    }

    const onSaveFlows = async () => {
        const fields = [
            'candidate_know_state',
            'object_special',
            'job_send_request',
            'standard_search_ignore',
            'input_me_list',
            'block_state',
            'candidate_type',
            'flow_note',
        ]

        await onUpdateExtractResult(currCandidate, fields)
    }

    const onSaveCandidateCategories = async () => {
        const fields = [
            'latest_stable_level',
            'highest_level',
            'new_work_level',
            'unknown_level',
        ]
        CANDIDATE_CATEGORY_FIELDS.forEach(item => {
            fields.push(item.key)
        })

        await onUpdateExtractResult(currCandidate, fields)
    }

    const onSaveBasicInfo = async () => {
        const fields = [
            'email_to_send',
            'full_name',
            'last_name',
            'vn_name',
            'foreign_name',
            'email_name',
            'gender',
            'caller_name_to_email',
            'vocative',
            'local_province',
            'local_area',
            'local_province_email',
            'local_area_email',
            'general_note',
            'personal_note'
        ]
        await onUpdateExtractResult(currCandidate, fields)
    }

    const onSaveContactInfo = async () => {
        const fields = IMPORT_EXCEL_CONTACT_FIELDS.map(item => {
            return item.key
        })
        await onUpdateExtractResult(currCandidate, fields)
    }

    const onAddContactItem = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(currCandidate[fieldName])
        if (!arr) {
            arr = []
        }

        // Validate
        if (PHONE_FILED_NAME.includes(fieldName)) {
            value = value.replaceAll(" ", "")
            if (value && !ValidateUtils.validatePhone(value)) {
                alert('Số điện thoại nhập không hợp lệ!');
                return;
            }
        } else if (EMAIL_FILED_NAME.includes(fieldName)) {
            value = value.replaceAll(" ", "")
            if (value && !ValidateUtils.validateEmail(value)) {
                alert('Email nhập không hợp lệ!');
                return;
            }
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            currCandidate[fieldName] = arr
            setCurrCandidate({...currCandidate})
            candidates[currentIndex][fieldName] = cloneDeep(currCandidate[fieldName]);
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }
    const onRemoveContactItem = (index, fieldName) => {
        let arr = cloneDeep(currCandidate[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            currCandidate[fieldName] = arr
            setCurrCandidate({...currCandidate})
            candidates[currentIndex][fieldName] = cloneDeep(currCandidate[fieldName]);
        }
    }

    const getColorClass = (excelStandardInfo, dbValue) => {
        if ((excelStandardInfo && !dbValue) || (excelStandardInfo && excelStandardInfo.length > 0 && dbValue.length === 0)) {
            return "text-success"
        }
        return ""
    }

    const diffValueInOptions = (excelValue, fieldType, constArray) => {
        // Mảng lưu value khác với options trong phần mềm
        let diffOptions = []
        constArray = arrayToLowerCase(constArray)
        if (fieldType === 'string') {
            if (excelValue && constArray && constArray.length > 0 && !constArray.includes(excelValue.toLowerCase())) {
                diffOptions.push(excelValue)
            }
        } else if (fieldType === 'array') {
            if (excelValue && excelValue.length > 0 && constArray && constArray.length > 0) {
                if (Array.isArray(excelValue)) {
                    excelValue.forEach(v => {
                        if (!constArray.includes(v.toLowerCase())) {
                            diffOptions.push(v.toLowerCase())
                        }
                    })
                } else if (excelValue && !constArray.includes(excelValue.toLowerCase())) {
                    diffOptions.push(excelValue.toLowerCase())
                }
            }
        } else if (fieldType === 'option') {
            if (excelValue && excelValue.length > 0 && constArray && constArray.length > 0) {
                const arrOptions = optionsToArray(constArray)
                if (Array.isArray(excelValue)) {
                    excelValue.forEach(v => {
                        if (v.value && !arrOptions.includes(v.value.toLowerCase())) {
                            diffOptions.push(v.value.toLowerCase())
                        }
                    })
                } else if (!arrOptions.includes(excelValue.toLowerCase())) {
                    diffOptions.push(excelValue.toLowerCase())
                }
            }
        }

        return diffOptions
    }

    const compareExcelAndDbValues = (excelValue, dbValue, fieldType) => {
        let isEqual = true
        if (fieldType === 'string') {
            isEqual = !excelValue || !dbValue || excelValue.length === 0 || dbValue.length === 0
                || compareString(excelValue, dbValue)
        } else if (fieldType === 'array') {
            isEqual = !excelValue || !dbValue || excelValue.length === 0 || dbValue.length === 0
                || compareArrays(excelValue, dbValue)
        } else if (fieldType === 'option') {
            isEqual = !excelValue || !dbValue || excelValue.length === 0 || dbValue.length === 0
                || compareOptions(excelValue, dbValue)
        }

        return isEqual
    }

    const excelDataValidation = (excelValue, dbValue, fieldType, constArray) => {
        if (!currCandidate.already_exists) {
            return "";
        }

        // Check same value and value exists in options
        let isEqual = compareExcelAndDbValues(excelValue, dbValue, fieldType)

        // Mảng lưu value khác với options trong phần mềm
        let diffOptions = diffValueInOptions(excelValue, fieldType, constArray)

        return <>
            {!isEqual &&
            <div className={"w-100"}>
                <span
                    className={"text-danger"}>Khác với giá trị lưu trong phần mềm.</span>
            </div>
            }
            {diffOptions.length > 0 &&
            <div className={"w-100 tex-right"}>
                <span className={"text-danger"}>Giá trị trong excel không trong danh sách options.</span>
            </div>}
        </>
    }

    const getValueDisplay = (excelStandardInfo, dbValue, fieldType, constArray) => {
        if (!excelStandardInfo && !dbValue) {
            return ""
        }

        if (constArray) {
            let diffInOptions = diffValueInOptions(excelStandardInfo, fieldType, constArray);
            if (diffInOptions.length > 0) {
                return ""
            }
        }

        if (fieldType === 'array' || fieldType === 'option') {
            if (!excelStandardInfo) {
                excelStandardInfo = []
            }

            if (!dbValue) {
                dbValue = []
            }

            if (excelStandardInfo.length === 0 && dbValue === 0) {
                return []
            }

            // if (constArray) {
            //     let diffInOptions = diffValueInOptions(excelStandardInfo, fieldType, constArray);
            //     if (diffInOptions.length > 0) {
            //         return []
            //     }
            // }

            if (excelStandardInfo.length > 0 && dbValue.length === 0) {
                return excelStandardInfo
            }

            if (dbValue.length > 0 && excelStandardInfo.length === 0) {
                return dbValue
            }

            if (fieldType === 'array') {
                if (compareArrays(excelStandardInfo, dbValue)) {
                    return excelStandardInfo
                }
                return []
            }
            if (fieldType === 'option') {
                if (compareOptions(excelStandardInfo, dbValue)) {
                    return excelStandardInfo
                }
                return []
            }
        }

        // process for field type is not array and not options
        if (excelStandardInfo && !dbValue) {
            return excelStandardInfo
        }
        if (!excelStandardInfo && dbValue) {
            return dbValue
        }

        if (excelStandardInfo.toLowerCase() === dbValue.toLowerCase()) {
            return excelStandardInfo
        }
        return ""
    }

    // So sánh giá trị excel sau khi chuẩn hóa với giá trị trong phần mềm của các trường
    const setAllFieldValuesDisplay = (canInfo) => {
        let newInfo = {}
        let provinces = [];
        Provinces.forEach(item => {
            provinces.push({
                value: item,
                label: item.charAt(0).toUpperCase() + item.slice(1)
            });
        });
        newInfo.industry = getValueDisplay(canInfo.industry, canInfo.db_candidate_info.industry, 'array', [])
        newInfo.industry_segment1 = getValueDisplay(canInfo.industry_segment1, canInfo.db_candidate_info.industry_segment1, 'array', [])
        newInfo.industry_segment2 = getValueDisplay(canInfo.industry_segment2, canInfo.db_candidate_info.industry_segment2, 'array', [])
        newInfo.function = getValueDisplay(canInfo.function, canInfo.db_candidate_info.function, 'array', [])
        newInfo.function_segment1 = getValueDisplay(canInfo.function_segment1, canInfo.db_candidate_info.function_segment1, 'array', [])
        newInfo.function_segment2 = getValueDisplay(canInfo.function_segment2, canInfo.db_candidate_info.function_segment2, 'array', [])
        newInfo.industry_function = getValueDisplay(canInfo.industry_function, canInfo.db_candidate_info.industry_function, 'option', INDUSTRY_FUNCTIONS)

        newInfo.special_certificate = getValueDisplay(canInfo.special_certificate, canInfo.db_candidate_info.special_certificate, 'string')
        newInfo.highest_level = getValueDisplay(canInfo.highest_level, canInfo.db_candidate_info.highest_level, 'string')
        newInfo.latest_stable_level = getValueDisplay(canInfo.latest_stable_level, canInfo.db_candidate_info.latest_stable_level, 'string')
        newInfo.local_province = getValueDisplay(canInfo.local_province, canInfo.db_candidate_info.local_province, 'option', provinces)
        newInfo.local_province_email = getValueDisplay(canInfo.local_province_email, canInfo.db_candidate_info.local_province_email, 'option', provinces)
        newInfo.local_area = getValueDisplay(canInfo.local_area, canInfo.db_candidate_info.local_area, 'option', AREA_OPTIONS)
        newInfo.local_area_email = getValueDisplay(canInfo.local_area_email, canInfo.db_candidate_info.local_area_email, 'option', AREA_OPTIONS)
        newInfo.local_note = getValueDisplay(canInfo.local_note, canInfo.db_candidate_info.local_note, 'string')

        newInfo.caller_name_to_email = getValueDisplay(canInfo.caller_name_to_email, canInfo.db_candidate_info.caller_name_to_email, 'string', CALLER_NAMES)
        newInfo.gender = getGenderByCallerName(newInfo.caller_name_to_email)

        newInfo.last_name = getValueDisplay(canInfo.last_name, canInfo.db_candidate_info.last_name, 'string')
        newInfo.last_name = newInfo.last_name ? capitalizeName(newInfo.last_name) : newInfo.last_name
        newInfo.vn_name = getValueDisplay(canInfo.vn_name, canInfo.db_candidate_info.vn_name, 'string')
        newInfo.vn_name = newInfo.vn_name ? capitalizeName(newInfo.vn_name) : newInfo.vn_name
        newInfo.foreign_name = getValueDisplay(canInfo.foreign_name, canInfo.db_candidate_info.foreign_name, 'string')
        newInfo.foreign_name = newInfo.foreign_name ? capitalizeName(newInfo.foreign_name) : newInfo.foreign_name
        newInfo.full_name = getValueDisplay(canInfo.full_name, canInfo.db_candidate_info.full_name, 'string')
        newInfo.full_name = newInfo.full_name ? capitalizeName(newInfo.full_name) : newInfo.full_name
        newInfo.email_name = getValueDisplay(canInfo.email_name, canInfo.db_candidate_info.email_name, 'string')
        newInfo.email_name = newInfo.email_name ? capitalizeName(newInfo.email_name) : newInfo.email_name
        newInfo.engagement_status = getValueDisplay(canInfo.engagement_status, canInfo.db_candidate_info.engagement_status, 'option', ENGAGEMENT_STATUS)
        newInfo.general_note = getValueDisplay(canInfo.general_note, canInfo.db_candidate_info.general_note, 'string')
        newInfo.origin = getValueDisplay(stringToOption(canInfo.origin), canInfo.db_candidate_info.origin, 'option', CANDIDATE_ORIGINS_OPTIONS)
        newInfo.origin_note = getValueDisplay(canInfo.origin_note, canInfo.db_candidate_info.origin_note, 'string')
        newInfo.phone = getValueDisplay(canInfo.phone, canInfo.db_candidate_info.phone, 'array')
        newInfo.email = getValueDisplay(canInfo.email, canInfo.db_candidate_info.email, 'array')
        newInfo.email_to_send = getValueDisplay(canInfo.email_to_send, canInfo.db_candidate_info.email_to_send, 'array')
        newInfo.vnw = getValueDisplay(canInfo.vnw, canInfo.db_candidate_info.vnw, 'array')
        newInfo.skype = getValueDisplay(canInfo.skype, canInfo.db_candidate_info.skype, 'array')
        newInfo.linkedin = getValueDisplay(canInfo.linkedin, canInfo.db_candidate_info.linkedin, 'array')
        newInfo.ever_email = getValueDisplay(canInfo.ever_email, canInfo.db_candidate_info.ever_email, 'array')
        newInfo.block_email = getValueDisplay(canInfo.block_email, canInfo.db_candidate_info.block_email, 'array')
        newInfo.appearence = getValueDisplay(canInfo.appearence, canInfo.db_candidate_info.appearence, 'string')
        return newInfo
    }

    const saveCommonFields = (can, commonData) => {
        // can.industry = appendArrayValues(can.industry, commonData.common_industry);
        // can.industry_function = appendArrayValues(can.industry_function, commonData.common_industry_function);
        // can.function = appendArrayValues(can.function, commonData.common_function);
        can.local_nationality = appendOptions(can.local_nationality, commonData.common_local_nationality);
        // can.origin = commonData.common_origin ? commonData.common_origin : can.origin;
        // can.origin_note = commonData.common_origin_note ? commonData.common_origin_note : can.origin_note;
        // can.general_note = commonData.common_general_note ? commonData.common_general_note : can.general_note;
        can.candidate_know_state = commonData.candidate_know_state ? commonData.candidate_know_state : can.candidate_know_state;
        can.object_special = commonData.object_special ? commonData.object_special : can.object_special;
        can.standard_search_ignore = commonData.standard_search_ignore ? commonData.standard_search_ignore : can.standard_search_ignore;
        can.input_me_list = commonData.input_me_list ? commonData.input_me_list : can.input_me_list;
        can.block_state = commonData.block_state ? commonData.block_state : can.block_state;
        can.candidate_type = commonData.candidate_type ? commonData.candidate_type : can.candidate_type;
        can.flow_note = commonData.flow_note ? commonData.flow_note : can.flow_note;
        can.show_hide_state = commonData.show_hide_state ? commonData.show_hide_state : can.show_hide_state;
        return can
    }

    const GetInputByAllUsers = async (can) => {
        can.allPersonalInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.Personal)
        can.allLocationsInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.Location)
        can.allContactsInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.Contacts)
        can.allCandidateCategoriesInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.CandidateCategory)
        can.allFlowCategoriesInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.FlowCategory)
        can.allCandidateNotesInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.CandidateNotes)
        can.allOriginInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.Origin)
        can.allCandidateCertificatesInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.CandidateCertificate)
        setCurrCandidate(cloneDeep(can))
        candidates[currentIndex] = cloneDeep(can);
    }

    const onCheckExists = async () => {
        let strEmails = concatStrings(currCandidate.email, currCandidate.ever_email)
        strEmails = concatStrings(strEmails, currCandidate.block_email)
        // if (!strEmails && !currCandidate.phone) {
        //     alert(`Vui lòng nhập email hoặc số điện thoại.`);
        //     return;
        // }

        let confirmMessage = ''
        if (!strEmails && !currCandidate.phone) {
            // alert(`Vui lòng nhập email hoặc số điện thoại.`);
            confirmMessage = 'Bạn vẫn muốn tiếp tục dù chưa nhập email và SĐT?'
            // return;
        } else if (currCandidate.require_email && !currCandidate.email) {
            // alert(`Vui lòng nhập email.`);
            confirmMessage = 'Có input email từ excel. Bạn vẫn muốn tiếp tục dù chưa nhập email?'
            // return;
        } else if (currCandidate.require_ever_email && !currCandidate.ever_email) {
            // alert(`Vui lòng nhập email.`);
            confirmMessage = 'Có input email từng dùng/lỗi từ excel. Bạn vẫn muốn tiếp tục dù chưa nhập email từng dùng/lỗi?'
            // return;
        } else if (currCandidate.require_block_email && !currCandidate.block_email) {
            // alert(`Vui lòng nhập email.`);
            confirmMessage = 'Có input email blocked từ excel. Bạn vẫn muốn tiếp tục dù chưa nhập email blocked?'
            // return;
        }

        else if (currCandidate.require_phone && !currCandidate.phone) {
            // alert(`Vui lòng nhập số điện thoại.`);
            confirmMessage = 'Có input SĐT từ excel. Bạn vẫn muốn tiếp tục dù chưa nhập SĐT?'
            // return;
        }

        if (confirmMessage) {
            if (window.confirm(confirmMessage) === false) {
                return;
            }
        }

        // Validate email
        if (!validateInputEmail(strEmails)) {
            return;
        }

        // Validate phone
        if (!validateInputPhone(currCandidate.phone)) {
            return;
        }

        // Check standard personal emails. Nếu user xác nhận ok sẽ tiếp tục xử lý tiếp theo.
        const confirm = await CandidateUtils.processWithoutPersonalEmail(stringToArray(currCandidate.email))
        if (!confirm) {
            return;
        }

        setCheckingExistsLoading(true);
        let payload = {candidate_info: currCandidate, extract_type: ExtractType.IMPORT_EXCEL}
        CandidateService.checkExists(payload)
            .then((res) => {
                if (res.sts_code === ResponseCode.EXISTS_GREATER_TWO_SAME_CV) {
                    alert("Person trùng với 2 persons khác trên phần mềm.")
                } else {
                    let con = res.content;
                    if (con.is_input_in_priority) {
                        confirmSubmitNotesWhenInputInPriorityTimeRange(con.priority_notify_id)
                    }
                    let canInfo = cloneDeep(con.standard_info)
                    // let canInfo = cloneDeep(currCandidate)
                    canInfo.standard_info = cloneDeep(con.standard_info)
                    canInfo.extract_result = cloneDeep(con.extract_result)
                    canInfo.db_candidate_info = con.db_candidate_info
                    canInfo.checkedExists = true;
                    canInfo.phone = stringToArray(currCandidate.phone)
                    canInfo.email = stringToArray(currCandidate.email)
                    canInfo.email_to_send = stringToArray(currCandidate.email)
                    canInfo.ever_email = stringToArray(currCandidate.ever_email)
                    canInfo.block_email = stringToArray(currCandidate.block_email)
                    canInfo.already_exists = !!res.content.exists;
                    if (canInfo.career_summaries.length > 0) {
                        canInfo.career_summaries[0].displayed_flag = true
                    }
                    let canDisplayValue = setAllFieldValuesDisplay(canInfo)
                    if (inputCommonData.hasSaveInputCommon) {
                        saveCommonFields(canDisplayValue, inputCommonData)
                    }

                    let displayInfo = {...canInfo, ...canDisplayValue}
                    setCurrCandidate(displayInfo)
                    candidates[currentIndex] = cloneDeep(displayInfo);
                    GetInputByAllUsers(displayInfo)
                }
            })
            .catch((error) => {
                // toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
            })
            .finally(() => {
                setCheckingExistsLoading(false);
            });

    };

    const checkEmailToSendInErrorBlockEmail = () => {
        const arrEmailToSend = stringToArray(currCandidate.email_to_send)
        if (arrEmailToSend && arrEmailToSend.length > 0) {
            let arrOtherEmail = [
                ...stringToArray(currCandidate.db_candidate_info.rarely_email),
                ...stringToArray(currCandidate.db_candidate_info.block_email),
                ...stringToArray(currCandidate.db_candidate_info.ever_email)
            ]
            if (twoArrayHaveSameElement(arrEmailToSend, arrOtherEmail)) {
                return <span className={'text-danger w-100 mb-2'}>
                    {Messages.emailToSendInErrorBlockEmails}
            </span>
            }
        }
        return ""

    }

    const checkEmailToSendInAllEmail = () => {
        const arrEmailToSend = stringToArray(currCandidate.email_to_send)
        if (arrEmailToSend && arrEmailToSend.length > 0) {
            let arrOtherEmail = [
                ...stringToArray(currCandidate.db_candidate_info.rarely_email),
                ...stringToArray(currCandidate.db_candidate_info.ever_email),
                ...stringToArray(currCandidate.db_candidate_info.block_email),
                ...stringToArray(currCandidate.db_candidate_info.email),
                ...stringToArray(currCandidate.db_candidate_info.email_to_send)]
            if (!checkEmailToSendInOtherEmails(arrEmailToSend, arrOtherEmail)) {
                return <span className={'text-danger w-100 mb-2'}>
                    {Messages.emailToSendNotInAllEmails}
            </span>
            }
        }

        return ""
    }

    const onChangeCommonInput = (event, fieldName) => {
        console.log('onChangeCommonInput');
        if (fieldName === 'common_industry' || fieldName === 'common_function') {
            let arr = cloneDeep(inputCommonData[fieldName])
            if (!arr) {
                arr = []
            }
            if (!arrayIncludeItem(arr, event)) {
                arr.push(event)
                inputCommonData[fieldName] = arr
            } else {
                alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
            }
        } else if (fieldName === 'common_industry_function' || fieldName === 'object_special'
            || fieldName === 'common_local_nationality') {
            if (fieldName === 'common_local_nationality' && checkNationalOptionsHaveExpatAndVN(event)) {
                showMessage(Messages.cannotNationalExpatAndVN)
                return;
            }
            inputCommonData[fieldName] = event;
        } else {
            inputCommonData[event.target.name] = event.target.value;
        }

        setInputCommonData(cloneDeep(inputCommonData));
    };

    const onRemoveCommonIndustryFunctionItem = (index, fieldName) => {
        if (fieldName === 'common_industry' || fieldName === 'common_function') {
            let arr = cloneDeep(inputCommonData[fieldName])
            if (arr && arr.length > 0) {
                if (arr.length === 1) {
                    arr = []
                } else {
                    arr.splice(index, 1);
                }
                inputCommonData[fieldName] = arr
                setInputCommonData({...inputCommonData})
            }
        }
    }

    const onChangeLanguages = (values) => {
        console.log("onChangeLanguages")
        candidates[currentIndex].languages = values;
        currCandidate.languages = values;
    };

    const onSaveCommonData = () => {
        console.log('onSaveCommonData');
        inputCommonData.hasSaveInputCommon = true
        let cans = candidates.map(can => {
            return saveCommonFields(can, inputCommonData)
        });
        saveCommonFields(currCandidate, inputCommonData)
        setCurrCandidate(cloneDeep(currCandidate));
        setCandidates(cloneDeep(cans));
    };

    const isSameErrorBlockEmail = (emails, errorEmails, blockEmails) => {
        if (!emails || emails.length === 0) {
            return false
        }
        let emailList = emails
        if (!Array.isArray(emailList)) {
            emailList = emails.split(";")
        }

        let sameErrorEmail = false
        if (errorEmails && errorEmails.length > 0) {
            let errorEmailList = errorEmails
            if (!Array.isArray(errorEmailList)) {
                errorEmailList = errorEmailList.split(";")
            }
            emailList.forEach(item => {
                if (errorEmailList.includes(item)) {
                    sameErrorEmail = true
                }
            })
        }

        let sameBlockEmail = false
        if (blockEmails && blockEmails.length > 0) {
            let blockEmailList = errorEmails
            if (!Array.isArray(blockEmailList)) {
                blockEmailList = blockEmailList.split(";")
            }
            emailList.forEach(item => {
                if (blockEmailList.includes(item)) {
                    sameBlockEmail = true
                }
            })
        }

        return <>
            {sameErrorEmail &&
            <div className={"w-100"}>
                <span
                    className={"text-danger"}>Email trùng với email bị lỗi.</span>
            </div>
            }
            {sameBlockEmail &&
            <div className={"w-100 tex-right"}>
                <span className={"text-danger"}>Email trùng với email đã bị block.</span>
            </div>}
        </>
    }
    return (
        <div className='container-fluid'>
            {candidates && candidates.length > 0 && showContent && (
                <div className={'card card-default'}>
                    <div className='card-header'>
                        <div className={'row'}>
                            <div className={'col-sm-6'}>
                                <h3 className='card-title col-sm-12'>Kết quả
                                    extract ({currentIndex + 1}/{candidates.length})</h3>
                            </div>
                            <div className={'card-tools row'}>
                                {hasInputCommon &&
                                <div className={'text-right'}>
                                    <a className='btn' href='#' data-toggle='modal' data-target='#inputCommonModal'
                                       ref={input => setBtnInputCommonData(input)}>
                                        <i className='fas fa-keyboard'/> Nhập chung
                                    </a>
                                </div>
                                }
                                <div className={'text-right'}>
                                    {currentIndex > 0 ?
                                        <a className='btn' href='#' onClick={onCandidateBack}>
                                            <i className='fas fa-arrow-left'/> Back
                                        </a> :
                                        <button className='btn' disabled type={'button'}>
                                            <i className='fas fa-arrow-left'/> Back
                                        </button>
                                    }
                                </div>
                                <div className={'text-right'}>
                                    {currentIndex < candidates.length - 1 ?
                                        <a className='btn' href='#' onClick={onCandidateNext}>
                                            <i className='fas fa-arrow-right'/> Next
                                        </a> :
                                        <button className='btn' disabled type={'button'}>
                                            <i className='fas fa-arrow-right'/> Next
                                        </button>
                                    }
                                </div>
                                <div className={'text-right float-right'}>
                                    <button className='btn btn-danger' type={'button'}
                                            onClick={() => onRemoveCandidate()}>Xóa UV
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {currCandidate &&
                    <div className={'card-body'}>
                        <div className={'row'}>
                            <div className={'col-sm-12'}
                                 style={{height: 800, overflow: 'auto'}}>
                                <div className='card card-default'>
                                    <div className='card-header'>
                                        {currCandidate.checkedExists &&
                                        <div className='card-tools row'>
                                            <button type='button' className='btn btn-primary mr-2 ml-3'
                                                    onClick={() => onUpdateExtractResult(currCandidate)}>Save All
                                            </button>
                                        </div>
                                        }
                                    </div>
                                    <div className='card-body'>
                                        {currCandidate.checkedExists &&
                                        <div className="alert alert-info" role="alert" style={{width: '100%'}}>
                                            {currCandidate.already_exists &&
                                            <b>Person đã tồn tại trên phần mềm với ID: &nbsp;
                                                <Link to={`/candidate/detail/${currCandidate.id}`} target="_blank"
                                                      rel="noopener noreferrer">{currCandidate.id}</Link>
                                            </b>
                                            }
                                            {!currCandidate.already_exists &&
                                            <b>Person chưa tồn tại trên phần mềm. Hệ thống đã tự động đăng ký Person này
                                                vào phần mềm với ID:&nbsp;
                                                <Link to={`/candidate/detail/${currCandidate.id}`} target="_blank"
                                                      rel="noopener noreferrer">{currCandidate.id}</Link>
                                            </b>
                                            }
                                        </div>
                                        }

                                        {currCandidate.save_success === true &&
                                        <div className="alert alert-info" role="alert" style={{width: '100%'}}>
                                            <b>Person được lưu thành công với ID: &nbsp;
                                                <Link to={`/candidate/detail/${currCandidate.id}`} target="_blank"
                                                      rel="noopener noreferrer">{currCandidate.id}</Link>
                                            </b>
                                        </div>
                                        }
                                        <ul className='nav nav-tabs' role='tablist'>
                                            <li className='nav-item'>
                                                <a className='nav-link active' data-toggle='tab'
                                                   href='#personal-tab'>Personal</a>
                                            </li>
                                            {currCandidate.checkedExists &&
                                            <>
                                                <li className='nav-item'>
                                                    <a className='nav-link' data-toggle='tab'
                                                       href='#career-summary-tab'>Career Summary</a>
                                                </li>
                                                <li className='nav-item'>
                                                    <a className='nav-link' data-toggle='tab' href='#categories-tab'>Phân loại, phân luồng</a>
                                                </li>
                                                <li className='nav-item'>
                                                    <a className='nav-link' data-toggle='tab'
                                                       href='#contacts-tab'>Contacts</a>
                                                </li>
                                                <li className='nav-item'>
                                                    <a className='nav-link' data-toggle='tab'
                                                       href='#language-tab'>Languages</a>
                                                </li>
                                                {/*<li className='nav-item'>*/}
                                                {/*    <a className='nav-link' data-toggle='tab' href='#others-tab'>Others</a>*/}
                                                {/*</li>*/}
                                            </>
                                            }
                                        </ul>

                                        <div className='tab-content'>
                                            <div id='personal-tab' className='tab-pane active'>
                                                {!currCandidate.checkedExists &&
                                                <>
                                                    <div className='input-group'>
                                                        <label className={'w-100'}><b>Email</b></label>
                                                        <input type='text' className='form-control'
                                                               value={currCandidate.email}
                                                               name={'email'}
                                                               onChange={event => onChangeInput(event)}/>
                                                        {currCandidate.extract_result.email &&
                                                        <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.email}</span>
                                                        </div>}
                                                    </div>
                                                    <div className='input-group mt-3'>
                                                        <label className={'w-100'}><b>Email TỪNG dùng/lỗi</b></label>
                                                        <input type='text' className='form-control'
                                                               value={currCandidate.ever_email}
                                                               name={'ever_email'}
                                                               onChange={event => onChangeInput(event)}/>
                                                        {currCandidate.extract_result.ever_email &&
                                                        <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.ever_email}</span>
                                                        </div>}
                                                    </div>
                                                    <div className='input-group mt-3'>
                                                        <label className={'w-100'}><b>Email blocked</b></label>
                                                        <input type='text' className='form-control'
                                                               value={currCandidate.block_email}
                                                               name={'block_email'}
                                                               onChange={event => onChangeInput(event)}/>
                                                        {currCandidate.extract_result.block_email &&
                                                        <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.block_email}</span>
                                                        </div>}
                                                    </div>
                                                    <div className='input-group mt-3'>
                                                        <label className={'w-100'}>Số điện thoại</label>
                                                        <input type='text' className='form-control'
                                                               value={currCandidate.phone ? currCandidate.phone : ''}
                                                               name={'phone'}
                                                               onChange={event => onChangeInput(event)}/>
                                                        {currCandidate.extract_result.phone &&
                                                        <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.phone}</span>
                                                        </div>}
                                                        {/*{currCandidate.db_candidate_info.phone &&*/}
                                                        {/*<div className={'col-sm-12'}>*/}
                                                        {/*<span*/}
                                                        {/*    className={''}>PM: {optionsToString(currCandidate.db_candidate_info.phone)}</span>*/}
                                                        {/*</div>*/}
                                                        {/*}*/}
                                                    </div>
                                                    <button type='button' className='btn btn-info btn-flat mt-3'
                                                            disabled={checkingExistsLoading}
                                                            onClick={() => onCheckExists()}>
                                                        Check trùng
                                                    </button>
                                                </>
                                                }
                                                {currCandidate.checkedExists &&
                                                <>
                                                    <div className='card card-default'>
                                                        <div className='card-header'>
                                                            <h3 className='card-title text-bold'>Thông tin cơ bản</h3>
                                                            <div className='card-tools'>
                                                                <button type='button'
                                                                        className='btn btn-primary'
                                                                        onClick={() =>
                                                                            onSaveBasicInfo()
                                                                        }
                                                                        >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className='card-body'>
                                                            {/*full name*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>Họ & tên (1) (BB)</label>
                                                                {excelDataValidation(currCandidate.standard_info.full_name,
                                                                    currCandidate.db_candidate_info.full_name, "string")}
                                                                <input type='text'
                                                                       className={`form-control ${getColorClass(currCandidate.standard_info.full_name, currCandidate.db_candidate_info.full_name, 'string')}`}
                                                                       value={currCandidate.full_name}
                                                                       name={'full_name'}
                                                                       onChange={event => onChangeInput(event)}/>

                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*        <button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*                onClick={() => onUpdateExtractResult(currCandidate, ['full_name'])}>*/}
                                                                {/*            Save*/}
                                                                {/*        </button>*/}
                                                                {/*    </span>*/}

                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.full_name}</span>
                                                                </div>
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>PM: {optionsToString(currCandidate.db_candidate_info.full_name)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='full_name'/>

                                                                <div className={'w-100'}>
                                                                <span className={'input-group-append'}>
                                                                    <button type='button'
                                                                            className='btn btn-warning btn-flat btn-sm'
                                                                            onClick={() => onRemoveSpace('full_name')}>
                                                                        Xóa blanks
                                                                    </button>
                                                                </span>
                                                                </div>
                                                            </div>
                                                            {/*last name*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>Họ (1) (BB)</label>
                                                                <input type='text' className={`form-control`}
                                                                       value={currCandidate.last_name}
                                                                       name={'last_name'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                {/*<div className={'w-100'}>*/}
                                                                {/*    <span*/}
                                                                {/*        className={''}>Excel: {currCandidate.extract_result.last_name}</span>*/}
                                                                {/*</div>*/}
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>PM: {optionsToString(currCandidate.db_candidate_info.last_name)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='last_name'/>

                                                            </div>
                                                            {/*name vn*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>Tên VN (1) (BB)</label>
                                                                <input type='text' className={`form-control`}
                                                                       value={currCandidate.vn_name}
                                                                       name={'vn_name'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*            onClick={() => onUpdateExtractResult(currCandidate, ['vn_name'])}>*/}
                                                                {/*        Save*/}
                                                                {/*    </button>*/}
                                                                {/*</span>*/}
                                                                {/*<div className={'w-100'}>*/}
                                                                {/*    <span*/}
                                                                {/*        className={''}>Excel: {currCandidate.extract_result.vn_name}</span>*/}
                                                                {/*</div>*/}
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>PM: {optionsToString(currCandidate.db_candidate_info.vn_name)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='vn_name'/>

                                                            </div>
                                                            {/*foreign_name*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-success'}>Tên nước
                                                                    ngoài</label>
                                                                {/*{excelDataValidation(currCandidate.standard_info.foreign_name,*/}
                                                                {/*    currCandidate.db_candidate_info.foreign_name, "string")}*/}
                                                                <input type='text'
                                                                       className={`form-control ${getColorClass(currCandidate.standard_info.foreign_name, currCandidate.db_candidate_info.foreign_name)}`}
                                                                       value={currCandidate.foreign_name}
                                                                       name={'foreign_name'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*            onClick={() => onUpdateExtractResult(currCandidate, ['foreign_name'])}>*/}
                                                                {/*        Save*/}
                                                                {/*    </button>*/}
                                                                {/*</span>*/}
                                                                {/*<div className={'w-100'}>*/}
                                                                {/*    <span*/}
                                                                {/*        className={''}>Excel: {currCandidate.extract_result.foreign_name}</span>*/}
                                                                {/*</div>*/}
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>PM: {optionsToString(currCandidate.db_candidate_info.foreign_name)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='foreign_name'/>

                                                            </div>
                                                            {/*email_name*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}><b>Tên (Email) (1) (BB)</b></label>
                                                                {excelDataValidation(currCandidate.standard_info.email_name,
                                                                    currCandidate.db_candidate_info.email_name, "string")}
                                                                <input type='text'
                                                                       className={`form-control ${getColorClass(currCandidate.standard_info.email_name, currCandidate.db_candidate_info.email_name)}`}
                                                                       value={currCandidate.email_name}
                                                                       name={'email_name'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*            onClick={() => onUpdateExtractResult(currCandidate, ['email_name'])}>*/}
                                                                {/*        Save*/}
                                                                {/*    </button>*/}
                                                                {/*</span>*/}
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.email_name}</span>
                                                                </div>
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>PM: {optionsToString(currCandidate.db_candidate_info.email_name)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='email_name'/>

                                                            </div>
                                                            {/*Gender*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-success'}>Giới
                                                                    tính</label>
                                                                {/*{excelDataValidation(currCandidate.standard_info.gender,*/}
                                                                {/*    currCandidate.db_candidate_info.gender, "string")}*/}
                                                                <select className={`form-control`}
                                                                        name={'gender'}
                                                                        value={currCandidate.gender}
                                                                        onChange={event => onChangeInput(event)}>
                                                                    <option value=''>&nbsp;</option>
                                                                    {GENDERS.map(item => {
                                                                        return <option value={item.toLowerCase()}
                                                                                       key={`gender_${item}`}>{item}</option>
                                                                    })}
                                                                </select>
                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*            onClick={() => onUpdateExtractResult(currCandidate, ['gender'])}>*/}
                                                                {/*        Save*/}
                                                                {/*    </button>*/}
                                                                {/*</span>*/}
                                                                {/*<div className={'w-100'}>*/}
                                                                {/*<span*/}
                                                                {/*    className={''}>Excel: {currCandidate.extract_result.gender}</span>*/}
                                                                {/*</div>*/}
                                                                <div className={'w-100'}>
                                                        <span
                                                            className={''}>PM: {optionsToString(currCandidate.db_candidate_info.gender)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='gender'/>

                                                            </div>
                                                            {/*caller_name_to_email*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}>Gọi UV là (email) (BB)</label>
                                                                {excelDataValidation(currCandidate.standard_info.caller_name_to_email,
                                                                    currCandidate.db_candidate_info.caller_name_to_email, "string", CALLER_NAMES)}
                                                                {/*<input type='text' className='form-control'*/}
                                                                {/*       value={currCandidate.caller_name_to_email?currCandidate.caller_name_to_email:''}*/}
                                                                {/*       name={'caller_name_to_email'}*/}
                                                                {/*       onChange={event => onChangeInput(event)} />*/}
                                                                <select
                                                                    className={`form-control ${getColorClass(currCandidate.standard_info.caller_name_to_email, currCandidate.db_candidate_info.caller_name_to_email)}`}
                                                                    name={'caller_name_to_email'}
                                                                    value={currCandidate.caller_name_to_email}
                                                                    onChange={event => onChangeInput(event)}>
                                                                    <option value=''>&nbsp;</option>
                                                                    <option value='anh'>anh</option>
                                                                    <option value='chị'>chị</option>
                                                                </select>
                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*            onClick={() => onUpdateExtractResult(currCandidate, ['caller_name_to_email'])}>*/}
                                                                {/*        Save*/}
                                                                {/*    </button>*/}
                                                                {/*</span>*/}
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.caller_name_to_email}</span>
                                                                </div>
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>PM: {optionsToString(currCandidate.db_candidate_info.caller_name_to_email)}</span>
                                                                </div>
                                                            </div>
                                                            {/*vocative*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>User xưng là (email) (BB)</label>
                                                                {/*<input type='text' className='form-control'*/}
                                                                {/*       value={currCandidate.vocative?currCandidate.vocative:''}*/}
                                                                {/*       name={'vocative'}*/}
                                                                {/*       onChange={event => onChangeInput(event)} />*/}
                                                                {/*{excelDataValidation(currCandidate.standard_info.vocative,*/}
                                                                {/*    currCandidate.db_candidate_info.vocative, "string")}*/}
                                                                <select className={`form-control`}
                                                                        name={'vocative'}
                                                                        value={currCandidate.vocative ? currCandidate.vocative : ""}
                                                                        onChange={event => onChangeInput(event)}>
                                                                    {currCandidate.caller_name_to_email === 'anh' || currCandidate.caller_name_to_email === 'chị' ?
                                                                        <option value={stringToLowerCase(userLoginInfo.name)}>
                                                                            {userLoginInfo.name}
                                                                        </option>
                                                                        :
                                                                        <>
                                                                            {/*<option value='anh'>anh</option>*/}
                                                                            <option
                                                                                value={stringToLowerCase(userLoginInfo.name)}>{userLoginInfo.name}</option>
                                                                            <option
                                                                                value={userLoginInfo.vocative}>{userLoginInfo.vocative}</option>
                                                                        </>
                                                                    }
                                                                </select>
                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*            onClick={() => onUpdateExtractResult(currCandidate, ['vocative'])}>*/}
                                                                {/*        Save*/}
                                                                {/*    </button>*/}
                                                                {/*</span>*/}
                                                                {/*<div className={'w-100'}>*/}
                                                                {/*    <span*/}
                                                                {/*        className={''}>Excel: {currCandidate.extract_result.caller_name_to_email}</span>*/}
                                                                {/*</div>*/}
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>PM: {optionsToString(currCandidate.db_candidate_info.caller_name_to_email)}</span>
                                                                </div>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}>Quốc tịch</label>
                                                                {excelDataValidation(
                                                                    currCandidate.standard_info.local_nationality,
                                                                    currCandidate.db_candidate_info.local_nationality,
                                                                    "option", CANDIDATE_NATIONALITIES
                                                                )}
                                                                <div style={{width: '100%'}}>
                                                                    <Select options={CANDIDATE_NATIONALITIES} isMulti
                                                                            value={currCandidate.local_nationality}
                                                                            className={`${getColorClass(currCandidate.standard_info.local_nationality, currCandidate.db_candidate_info.local_nationality)}`}
                                                                            onChange={value => {
                                                                                onChangeLocalNationality(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>Excel: {currCandidate.extract_result.local_nationality}</span>
                                                                </div>

                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>PM: {optionsToString(currCandidate.db_candidate_info.local_nationality)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_nationality'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}>Nước ngoài từng làm việc</label>
                                                                {excelDataValidation(
                                                                    currCandidate.standard_info.local_ever_work_nationality,
                                                                    currCandidate.db_candidate_info.local_ever_work_nationality,
                                                                    "option", COUNTRIES
                                                                )}
                                                                <div style={{width: '100%'}}>
                                                                    <Select options={COUNTRIES} isMulti
                                                                            value={currCandidate.local_ever_work_nationality}
                                                                            className={`${getColorClass(currCandidate.standard_info.local_ever_work_nationality, currCandidate.db_candidate_info.local_ever_work_nationality)}`}
                                                                            onChange={value => {
                                                                                onChangeLocalEverWorkNationality(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>Excel: {currCandidate.extract_result.local_ever_work_nationality}</span>
                                                                </div>

                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>PM: {optionsToString(currCandidate.db_candidate_info.local_ever_work_nationality)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_ever_work_nationality'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}>Location (Tỉnh)</label>
                                                                {excelDataValidation(
                                                                    currCandidate.standard_info.local_province,
                                                                    currCandidate.db_candidate_info.local_province,
                                                                    "option", provinceOptions
                                                                )}
                                                                <div style={{width: '100%'}}>
                                                                    <Select options={provinceOptions} isMulti
                                                                            value={currCandidate.local_province}
                                                                            className={`${getColorClass(currCandidate.standard_info.local_province, currCandidate.db_candidate_info.local_province)}`}
                                                                            onChange={value => {
                                                                                onChangeLocalProvince(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>Excel: {currCandidate.extract_result.local_province}</span>
                                                                </div>

                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>PM: {optionsToString(currCandidate.db_candidate_info.local_province)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_province'/>
                                                            </div>
                                                            {/*local_area*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-success'}>Location
                                                                    (Vùng,miền)</label>
                                                                {/*{excelDataValidation(*/}
                                                                {/*    currCandidate.standard_info.local_area,*/}
                                                                {/*    currCandidate.db_candidate_info.local_area,*/}
                                                                {/*    "option", AREA_OPTIONS*/}
                                                                {/*)}*/}
                                                                {/*<input type='text' className='form-control'*/}
                                                                {/*       value={currCandidate.local_area ? currCandidate.local_area : ''}*/}
                                                                {/*       name={'local_area'}*/}
                                                                {/*       onChange={event => onChangeInput(event)} />*/}
                                                                <div style={{width: '100%'}}>
                                                                    <Select options={AREA_OPTIONS} isMulti
                                                                            value={currCandidate.local_area}
                                                                            className={`${getColorClass(currCandidate.standard_info.local_area, currCandidate.db_candidate_info.local_area)}`}
                                                                            onChange={value => {
                                                                                onChangeLocalArea(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*            onClick={() => onUpdateExtractResult(currCandidate, ['local_area'])}>*/}
                                                                {/*        Save*/}
                                                                {/*    </button>*/}
                                                                {/*</span>*/}
                                                                {/*<div className={'w-100'}>*/}
                                                                {/*    <span*/}
                                                                {/*        className={''}>Excel: {currCandidate.extract_result.local_area}</span>*/}
                                                                {/*</div>*/}

                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>PM: {optionsToString(currCandidate.db_candidate_info.local_area)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_area'/>
                                                            </div>
                                                            {/*local_province_email*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-success'}><b>Location Tỉnh
                                                                    (Email) (BB)</b></label>
                                                                {/*{excelDataValidation(*/}
                                                                {/*    currCandidate.standard_info.local_province_email,*/}
                                                                {/*    currCandidate.db_candidate_info.local_province_email,*/}
                                                                {/*    "option", provinceOptions*/}
                                                                {/*)}*/}
                                                                {/*<input type='text' className='form-control'*/}
                                                                {/*       value={currCandidate.local_province_email?currCandidate.local_province_email:currCandidate.local_province}*/}
                                                                {/*       name={'local_province_email'}*/}
                                                                {/*       onChange={event => onChangeInput(event)} />*/}
                                                                <div style={{width: '100%'}}>
                                                                    <Select options={provinceOptions} isMulti
                                                                            value={currCandidate.local_province_email}
                                                                        // className={`${getColorClass(currCandidate.standard_info.local_province_email, currCandidate.db_candidate_info.local_province_email)}`}
                                                                            onChange={value => {
                                                                                onChangeLocalProvinceEmail(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                {/*    <span className={'input-group-append'}>*/}
                                                                {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*            onClick={() => onUpdateExtractResult(currCandidate, ['local_province_email'])}>*/}
                                                                {/*        Save*/}
                                                                {/*    </button>*/}
                                                                {/*</span>*/}
                                                                {/*<div className={'w-100'}>*/}
                                                                {/*    <span*/}
                                                                {/*        className={''}>Excel: {currCandidate.extract_result.local_province_email}</span>*/}
                                                                {/*</div>*/}

                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>PM: {optionsToString(currCandidate.db_candidate_info.local_province_email)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_province_email'/>
                                                            </div>
                                                            {/*local_area_email*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-success'}><b>Location Miền
                                                                    (Email) (BB)</b></label>
                                                                {/*{excelDataValidation(*/}
                                                                {/*    currCandidate.standard_info.local_area_email,*/}
                                                                {/*    currCandidate.db_candidate_info.local_area_email,*/}
                                                                {/*    "option", AREA_OPTIONS*/}
                                                                {/*)}*/}
                                                                {/*<input type='text' className='form-control'*/}
                                                                {/*       value={currCandidate.local_area_email ? currCandidate.local_area_email : currCandidate.local_area}*/}
                                                                {/*       name={'local_area_email'}*/}
                                                                {/*       onChange={event => onChangeInput(event)} />*/}
                                                                <div style={{width: '100%'}}>
                                                                    <Select options={AREA_OPTIONS} isMulti
                                                                            value={currCandidate.local_area_email}
                                                                        // className={`${getColorClass(currCandidate.local_area_email, currCandidate.db_candidate_info.local_area_email)}`}
                                                                            onChange={value => {
                                                                                onChangeLocalAreaEmail(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*            onClick={() => onUpdateExtractResult(currCandidate, ['local_area_email'])}>*/}
                                                                {/*        Save*/}
                                                                {/*    </button>*/}
                                                                {/*</span>*/}
                                                                {/*<div className={'w-100'}>*/}
                                                                {/*    <span*/}
                                                                {/*        className={''}>Excel: {currCandidate.extract_result.local_area_email}</span>*/}
                                                                {/*</div>*/}

                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>PM: {optionsToString(currCandidate.db_candidate_info.local_area_email)}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_area_email'/>
                                                            </div>
                                                            {/*local_note*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}><b>Location Note</b></label>
                                                                {excelDataValidation(
                                                                    currCandidate.standard_info.local_note,
                                                                    currCandidate.db_candidate_info.local_note, "string")}
                                                                <input type='text'
                                                                       className={`form-control ${getColorClass(currCandidate.standard_info.local_note, currCandidate.db_candidate_info.local_note)}`}
                                                                       value={currCandidate.local_note}
                                                                       name={'local_note'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                {/*    <span className={'input-group-append'}>*/}
                                                                {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*            onClick={() => onUpdateExtractResult(currCandidate, ['local_note'])}>*/}
                                                                {/*        Save*/}
                                                                {/*    </button>*/}
                                                                {/*</span>*/}
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.local_note}</span>
                                                                </div>

                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>PM: {currCandidate.db_candidate_info.local_note}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_note'/>
                                                            </div>

                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}><b>Nguồn UV</b></label>
                                                                {excelDataValidation(stringToOption(currCandidate.standard_info.origin),
                                                                    currCandidate.db_candidate_info.origin, "option", CANDIDATE_ORIGINS_OPTIONS)}
                                                                {/*<select className={`form-control ${getColorClass(currCandidate.standard_info.origin, currCandidate.db_candidate_info.origin)}`}*/}
                                                                {/*        value={currCandidate.origin}*/}
                                                                {/*        name={'origin'}*/}
                                                                {/*        onChange={event => onChangeInput(event)}>*/}
                                                                {/*    {CANDIDATE_ORIGINS.map((item, index) => {*/}
                                                                {/*        return <option value={item.toLowerCase()}>{item}</option>*/}
                                                                {/*    })}*/}
                                                                {/*</select>*/}
                                                                <Select
                                                                    className={`w-100 ${getColorClass(currCandidate.standard_info.origin, currCandidate.db_candidate_info.origin)}`}
                                                                    name={'origin'}
                                                                    options={CANDIDATE_ORIGINS_OPTIONS}
                                                                    isMulti
                                                                    value={currCandidate.origin}
                                                                    onChange={value => onChangeInput(value, 'origin')}>
                                                                </Select>
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>Excel: {currCandidate.extract_result.origin}</span>
                                                                </div>
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>PM: {optionsToString(currCandidate.db_candidate_info.origin)}</span>
                                                                </div>
                                                                <AllUserInputField arrInfo={currCandidate.allOriginInfo}
                                                                                   field='origin'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}><b>Notes (Nguồn
                                                                    UV)</b></label>
                                                                {excelDataValidation(currCandidate.standard_info.origin_note,
                                                                    currCandidate.db_candidate_info.origin_note, "string")}
                                                                <input type='text'
                                                                       className={`form-control ${getColorClass(currCandidate.standard_info.origin_note, currCandidate.db_candidate_info.origin_note)}`}
                                                                       value={currCandidate.origin_note}
                                                                       name={'origin_note'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                {/*<button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*        onClick={() => onUpdateExtractResult(currCandidate, ['origin_note'])}>*/}
                                                                {/*    Save*/}
                                                                {/*</button>*/}
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.origin_note}</span>
                                                                </div>

                                                                <div className={'w-100'}>
                                                        <span
                                                            className={''}>PM: {currCandidate.db_candidate_info.origin_note}</span>
                                                                </div>
                                                                <AllUserInputField arrInfo={currCandidate.allOriginInfo}
                                                                                   field='origin_note'/>
                                                            </div>
                                                            {/*local_note*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}><b>General Note</b></label>
                                                                {excelDataValidation(currCandidate.standard_info.general_note,
                                                                    currCandidate.db_candidate_info.general_note, "string")}
                                                                <input type='text'
                                                                       className={`form-control ${getColorClass(currCandidate.standard_info.general_note, currCandidate.db_candidate_info.general_note)}`}
                                                                       value={currCandidate.general_note}
                                                                       name={'general_note'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*<button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*        onClick={() => onUpdateExtractResult(currCandidate, ['general_note'])}>*/}
                                                                {/*    Save*/}
                                                                {/*</button>*/}
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.general_note}</span>
                                                                </div>

                                                                <div className={'w-100'}>
                                                        <span
                                                            className={''}>PM: {currCandidate.db_candidate_info.general_note}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allCandidateNotesInfo}
                                                                    field='general_note'/>
                                                                {/*</span>*/}
                                                            </div>
                                                            {/*special_certificate*/}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}><b>Chứng chỉ đặc
                                                                    biệt</b></label>
                                                                {excelDataValidation(currCandidate.standard_info.special_certificate,
                                                                    currCandidate.db_candidate_info.special_certificate, "string")}
                                                                <input type='text'
                                                                       className={`form-control ${getColorClass(currCandidate.standard_info.special_certificate, currCandidate.db_candidate_info.special_certificate)}`}
                                                                       value={currCandidate.special_certificate}
                                                                       name={'special_certificate'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*<button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*        onClick={() => onUpdateExtractResult(currCandidate, ['special_certificate'])}>*/}
                                                                {/*    Save*/}
                                                                {/*</button>*/}
                                                                {/*</span>*/}
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.special_certificate}</span>
                                                                </div>

                                                                <div className={'w-100'}>
                                                        <span
                                                            className={''}>PM: {currCandidate.db_candidate_info.special_certificate}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allCandidateCertificatesInfo}
                                                                    field='special_certificate'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}>Engagement Status</label>
                                                                {
                                                                    excelDataValidation(currCandidate.standard_info.engagement_status,
                                                                        currCandidate.db_candidate_info.engagement_status, "option", ENGAGEMENT_STATUS)
                                                                }
                                                                <Select options={ENGAGEMENT_STATUS}
                                                                        className={`w-100 ${getColorClass(currCandidate.engagement_status, currCandidate.db_candidate_info.engagement_status)}`}
                                                                        value={currCandidate.engagement_status}
                                                                        isMulti
                                                                        name={'engagement_status'}
                                                                        onChange={values => onChangeInput(values, 'engagement_status')}>
                                                                </Select>
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {optionsToString(currCandidate.extract_result.engagement_status)}</span>
                                                                </div>

                                                                <div className={'w-100'}>
                                                        <span
                                                            className={''}>PM: {optionsToString(currCandidate.db_candidate_info.engagement_status)}</span>
                                                                </div>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}><b>Ngoại hình</b></label>
                                                                {excelDataValidation(currCandidate.standard_info.appearence,
                                                                    currCandidate.db_candidate_info.appearence, "string")}
                                                                <input type='text'
                                                                       className={`form-control ${getColorClass(currCandidate.standard_info.appearence, currCandidate.db_candidate_info.appearence)}`}
                                                                       value={currCandidate.appearence}
                                                                       name={'appearence'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                {/*<span className={'input-group-append'}>*/}
                                                                {/*<button type='button' className='btn btn-info btn-flat'*/}
                                                                {/*        onClick={() => onUpdateExtractResult(currCandidate, ['special_certificate'])}>*/}
                                                                {/*    Save*/}
                                                                {/*</button>*/}
                                                                {/*</span>*/}
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>Excel: {currCandidate.extract_result.appearence}</span>
                                                                </div>

                                                                <div className={'w-100'}>
                                                        <span
                                                            className={''}>PM: {currCandidate.db_candidate_info.appearence}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='appearence'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}><b>Note Thông tin cá nhân</b></label>
                                                                <input type='text' className={`form-control`}
                                                                       value={currCandidate.personal_note}
                                                                       name={'personal_note'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>PM: {currCandidate.db_candidate_info.personal_note}</span>
                                                                </div>
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='personal_note'/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                }
                                            </div>
                                            {currCandidate.checkedExists &&
                                            <>
                                                <div id='career-summary-tab' className='tab-pane fade'>
                                                    <div className='card card-default'>
                                                        <div className='card-header'>
                                                            <h3 className='card-title text-bold'>Danh sách career
                                                                summary</h3>
                                                            <div className={'card-tools'}>
                                                                <div className={'text-right'}>
                                                                    <button className='btn btn-primary mr-3'
                                                                            type={'button'}
                                                                            onClick={() => onSaveCareerSummary()}>
                                                                        <i className='fas fa-save'/> Save
                                                                    </button>
                                                                    <button className='btn btn-default mr-3'
                                                                            type={'button'}
                                                                            onClick={() => onSortCareerSummary()}>
                                                                        <i className='fas fa-sync'/> Sắp xếp
                                                                    </button>
                                                                    <button className='btn btn-success mr-3'
                                                                            type={'button'}
                                                                            onClick={() => onAddCareerSummary()}>
                                                                        <i className='fas fa-plus'/> Thêm
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='card-body table-responsive p-0 w-100'>
                                                            <table
                                                                className='table table-hover table-bordered text-nowrap'
                                                                style={{
                                                                    maxHeight: '80vh',
                                                                    overflow: 'scroll',
                                                                    minHeight: 300
                                                                }}
                                                            >
                                                                <thead>
                                                                <tr>
                                                                    <th>STT</th>
                                                                    <th>Time bắt đầu</th>
                                                                    <th>Time có
                                                                        làm&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                                                    <th>Time kết thúc</th>
                                                                    <th className={'text-danger'}>Company (TT
                                                                        gốc) (BB)&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                    <th className={'text-danger'}>Title (BB) &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                    <th>Email Công ty  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                    <th>Số ĐT Công ty &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                    <th>Note
                                                                        company&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                    <th>Company
                                                                        location&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                    <th>Company
                                                                        industry&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                    <th>Note of
                                                                        period&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                    <th>Displayed
                                                                        period&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                    <th>Hành động</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {currCandidate && currCandidate.career_summaries && currCandidate.career_summaries.length > 0
                                                                && currCandidate.career_summaries.map((item, index) => {
                                                                    let bgColor = item.from_excel ? 'bg-info' : ''
                                                                    if (item.created_user && userLoginInfo.id !== item.created_user) {
                                                                        bgColor = "bg-success"
                                                                    }
                                                                    return <tr key={`career_summary_${index}`}>
                                                                        <td className={bgColor}
                                                                            title={`Người input: ${item.user_input}; Ngày NL mới nhất: ${item.updated_date_time}`}>{index + 1}</td>
                                                                        <td>
                                                                            <div className={'row'}>
                                                                                <div className={'col-sm-12'}>
                                                                                    <Select options={workYears}
                                                                                            placeholder={'Năm'}
                                                                                            isDisabled={userLoginInfo.id !== item.created_user}
                                                                                            value={item.work_start_year ? item.work_start_year : ''}
                                                                                            onChange={value => {
                                                                                                onChangeWorkTime(index, value, 'work_start_year');
                                                                                            }}
                                                                                    />
                                                                                </div>
                                                                                <div className={'col-sm-12 mt-1'}>
                                                                                    <Select options={workMonths}
                                                                                            placeholder={'Tháng'}
                                                                                            isDisabled={userLoginInfo.id !== item.created_user}
                                                                                            value={item.work_start_month ? item.work_start_month : ''}
                                                                                            onChange={value => {
                                                                                                onChangeWorkTime(index, value, 'work_start_month');
                                                                                            }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className={'row'}>
                                                                                <div className={'col-sm-12'}>
                                                                                    <Select options={workYears}
                                                                                            placeholder={'Năm'}
                                                                                            isDisabled={userLoginInfo.id !== item.created_user}
                                                                                            value={item.work_year ? item.work_year : ''}
                                                                                            onChange={value => {
                                                                                                onChangeWorkTime(index, value, 'work_year');
                                                                                            }}
                                                                                    />
                                                                                </div>
                                                                                <div className={'col-sm-12 mt-1'}>
                                                                                    <Select options={workMonths}
                                                                                            placeholder={'Tháng'}
                                                                                            isDisabled={userLoginInfo.id !== item.created_user}
                                                                                            value={item.work_month ? item.work_month : ''}
                                                                                            onChange={value => {
                                                                                                onChangeWorkTime(index, value, 'work_month');
                                                                                            }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className={'row'}>
                                                                                <div className={'col-sm-12'}>
                                                                                    <Select options={workYears}
                                                                                            placeholder={'Năm'}
                                                                                            isDisabled={userLoginInfo.id !== item.created_user}
                                                                                            value={item.work_end_year ? item.work_end_year : ''}
                                                                                            onChange={value => {
                                                                                                onChangeWorkTime(index, value, 'work_end_year');
                                                                                            }}
                                                                                    />
                                                                                </div>
                                                                                <div className={'col-sm-12 mt-1'}>
                                                                                    <Select options={workMonths}
                                                                                            placeholder={'Tháng'}
                                                                                            isDisabled={userLoginInfo.id !== item.created_user}
                                                                                            value={item.work_end_month ? item.work_end_month : ''}
                                                                                            onChange={value => {
                                                                                                onChangeWorkTime(index, value, 'work_end_month');
                                                                                            }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                        <textarea className='form-control'
                                                                                  value={item.origin_company ? item.origin_company : ''}
                                                                                  name={'origin_company'}
                                                                                  disabled={userLoginInfo.id !== item.created_user}
                                                                                  onChange={event => onChangeCareerInput(event, index)}/>
                                                                            <div className={'col-sm-12'}>
                                                                            <span className={'input-group-append mt-2'}>
                                                                                <button type='button'
                                                                                        className='btn btn-warning btn-flat btn-sm'
                                                                                        disabled={userLoginInfo.id !== item.created_user}
                                                                                        onClick={() => onRemoveSpace('origin_company', index)}>
                                                                                    Xóa blanks
                                                                                </button>
                                                                            </span>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <input type='text' className='form-control'
                                                                                   value={item.title ? item.title : ''}
                                                                                   name={'title'}
                                                                                   disabled={userLoginInfo.id !== item.created_user}
                                                                                   onChange={event => onChangeCareerInput(event, index)}/>
                                                                            <div className={'col-sm-12'}>
                                                                            <span className={'input-group-append mt-2'}>
                                                                                <button type='button'
                                                                                        disabled={userLoginInfo.id !== item.created_user}
                                                                                        className='btn btn-warning btn-flat btn-sm'
                                                                                        onClick={() => onRemoveSpace('title', index)}>
                                                                                    Xóa blanks
                                                                                </button>
                                                                            </span>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <input type='text' className='form-control'
                                                                                   value={item.company_email ? item.company_email : ''}
                                                                                   name={'company_email'}
                                                                                   disabled={userLoginInfo.id !== item.created_user}
                                                                                   onChange={event => onChangeCareerInput(event, index)}/>
                                                                        </td>
                                                                        <td>
                                                                            <input type='text' className='form-control'
                                                                                   value={item.company_phone ? item.company_phone : ''}
                                                                                   name={'company_phone'}
                                                                                   disabled={userLoginInfo.id !== item.created_user}
                                                                                   onChange={event => onChangeCareerInput(event, index)}/>
                                                                        </td>
                                                                        <td>
                                                                        <textarea className='form-control'
                                                                                  value={item.company_note ? item.company_note : ''}
                                                                                  name={'company_note'}
                                                                                  disabled={userLoginInfo.id !== item.created_user}
                                                                                  onChange={event => onChangeCareerInput(event, index)}/>
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control'
                                                                                   type={"text"}
                                                                                   disabled={userLoginInfo.id !== item.created_user}
                                                                                   value={item.company_province_note ? item.company_province_note : ''}
                                                                                   name={'company_province_note'}
                                                                                   onChange={event => onChangeCareerInput(event, index)}/>
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control'
                                                                                   type={"text"}
                                                                                   disabled={userLoginInfo.id !== item.created_user}
                                                                                   value={item.company_industry_note ? item.company_industry_note : ''}
                                                                                   name={'company_industry_note'}
                                                                                   onChange={event => onChangeCareerInput(event, index)}/>
                                                                        </td>
                                                                        <td>
                                                                        <textarea className='form-control'
                                                                                  value={item.note_of_period ? item.note_of_period : ''}
                                                                                  name={'note_of_period'}
                                                                                  disabled={userLoginInfo.id !== item.created_user}
                                                                                  onChange={event => onChangeCareerInput(event, index)}/>
                                                                        </td>
                                                                        <td>
                                                                            <div className='checkbox'>
                                                                                <input className='form-control'
                                                                                       type={'radio'}
                                                                                       value={item.displayed_flag}
                                                                                       checked={item.displayed_flag}
                                                                                       name={`displayed_flag`}
                                                                                       disabled={userLoginInfo.id !== item.created_user}
                                                                                       onChange={event => onChangeCareerInput(event, index)}/>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <button className='btn btn-danger'
                                                                                    type='button'
                                                                                    disabled={userLoginInfo.id !== item.created_user}
                                                                                    onClick={() => onDeleteCareerSummary(index)}>
                                                                                Xóa
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id='contacts-tab' className='tab-pane fade'>
                                                    <div className='card card-default'>
                                                        <div className='card-header'>
                                                            <h3 className='card-title text-bold'>Contacts</h3>
                                                            <div className='card-tools row'>
                                                                <button type='button' className='btn btn-primary'
                                                                        onClick={() => onSaveContactInfo()}>Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className='card-body pt-0'>
                                                            {IMPORT_EXCEL_CONTACT_FIELDS.map((field, i) => {
                                                                let fieldValue = currCandidate[field.key] ? currCandidate[field.key] : []
                                                                let standardValue = currCandidate.standard_info[field.key] ? currCandidate.standard_info[field.key] : []
                                                                return <div className='input-group mt-3'>
                                                                    <label className={'w-100'}>{field.label}</label>
                                                                    {field.key !== 'linkedin' && excelDataValidation(standardValue,
                                                                        currCandidate.db_candidate_info[field.key], "array")}
                                                                    {field.key === 'email_to_send' && checkEmailToSendInErrorBlockEmail()
                                                                    }
                                                                    {field.key === 'email_to_send' &&
                                                                        checkEmailToSendInAllEmail()
                                                                    }
                                                                    <ReactChipInput
                                                                        classes={`class1 class2 w-100 ${getColorClass(standardValue, currCandidate.db_candidate_info[field.key])}`}
                                                                        chips={fieldValue}
                                                                        onSubmit={value => onAddContactItem(value, field.key)}
                                                                        onRemove={index => onRemoveContactItem(index, field.key)}
                                                                    />
                                                                    <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>Excel: {arrayToString(currCandidate.extract_result[field.key])}</span>
                                                                    </div>

                                                                    <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>PM: {arrayToString(currCandidate.db_candidate_info[field.key])}</span>
                                                                    </div>
                                                                    <AllUserInputField arrInfo={currCandidate.allContactsInfo} field={field.key}/>
                                                                </div>
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id='categories-tab' className='tab-pane fade'>
                                                    <div className='card card-default'>
                                                        <div className='card-header'>
                                                            <h3 className='card-title text-bold'>Phân loại</h3>
                                                            <div className={'card-tools'}>
                                                                <div className={'text-right'}>
                                                                    <button className='btn btn-primary'
                                                                            type={'button'}
                                                                            onClick={() => onSaveCandidateCategories()}>
                                                                        <i className='fas fa-save'/> Save
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='card-body'>
                                                            {CANDIDATE_CATEGORY_FIELDS.map((field, i) => {
                                                                let fieldValue = currCandidate[field.key] ? currCandidate[field.key] : []
                                                                let standardValue = currCandidate.standard_info[field.key] ? currCandidate.standard_info[field.key] : []
                                                                if (field.key === 'industry_function') {
                                                                    return <div className='input-group mt-3 d-none'>
                                                                        <label className={'w-100'}><b>Industry Function
                                                                            (Linkedin)</b></label>
                                                                        {excelDataValidation(standardValue,
                                                                            currCandidate.db_candidate_info[field.key], "option", INDUSTRY_FUNCTIONS)}
                                                                        <div style={{width: '100%'}}>
                                                                            <Select options={INDUSTRY_FUNCTIONS} isMulti
                                                                                    classes={`${getColorClass(currCandidate.standard_info.industry_function, currCandidate.db_candidate_info.industry_function)}`}
                                                                                    value={currCandidate.industry_function}
                                                                                    onChange={value => {
                                                                                        onChangeIndustryFunctionItem(value, 'industry_function');
                                                                                    }}
                                                                            />
                                                                            <div className={'w-100'}>
                                                                            <span
                                                                                className={''}>Excel: {optionsToString(currCandidate.extract_result.industry_function)}</span>
                                                                            </div>
                                                                            <div className={'w-100'}>
                                                                            <span
                                                                                className={''}>PM: {optionsToString(currCandidate.db_candidate_info.industry_function)}</span>
                                                                            </div>
                                                                            <AllUserInputField arrInfo={currCandidate.allCandidateCategoriesInfo} field='industry_function'/>
                                                                        </div>
                                                                        {/*<span className={'input-group-append'}>*/}
                                                                        {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                        {/*            onClick={() => onUpdateExtractResult(currCandidate, ['industry_function'])}>*/}
                                                                        {/*        Save*/}
                                                                        {/*    </button>*/}
                                                                        {/*</span>*/}
                                                                    </div>
                                                                }
                                                                return <div className='input-group mt-3'>
                                                                    <label className={'w-100'}>{field.label}</label>
                                                                    {excelDataValidation(standardValue,
                                                                        currCandidate.db_candidate_info[field.key], "array", [])}
                                                                    <div style={{width: '100%'}}>
                                                                        <ReactChipInput
                                                                            classes={`class1 class2 w-100 ${getColorClass(standardValue, currCandidate.db_candidate_info[field.key])}`}
                                                                            chips={fieldValue}
                                                                            onSubmit={value => onAddIndustryFunctionItem(value, field.key)}
                                                                            onRemove={index => onRemoveIndustryFunctionItem(index, field.key)}
                                                                        />
                                                                        <div className={'w-100'}>
                                                                        <span
                                                                            className={''}>Excel: {currCandidate.extract_result[field.key]}</span>
                                                                        </div>

                                                                        <div className={'w-100'}>
                                                                        <span
                                                                            className={''}>PM: {arrayToString(currCandidate.db_candidate_info[field.key])}</span>
                                                                        </div>
                                                                        <AllUserInputField arrInfo={currCandidate.allCandidateCategoriesInfo} field={field.key}/>
                                                                    </div>
                                                                    {/*    <span className={'input-group-append'}>*/}
                                                                    {/*    <button type='button' className='btn btn-info btn-flat'*/}
                                                                    {/*            onClick={() => onUpdateExtractResult(currCandidate, [field.key])}>*/}
                                                                    {/*        Save*/}
                                                                    {/*    </button>*/}
                                                                    {/*</span>*/}
                                                                </div>
                                                            })}
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-success'}><b>Latest Stable
                                                                    Level</b></label>
                                                                {excelDataValidation(currCandidate.standard_info.latest_stable_level,
                                                                    currCandidate.db_candidate_info.latest_stable_level, "string")}
                                                                <select className={`form-control`}
                                                                        value={currCandidate.latest_stable_level}
                                                                        name={'latest_stable_level'}
                                                                        onChange={event => onChangeInput(event)}>
                                                                    {LATEST_STABLE_LEVELS.map((item, index) => {
                                                                        return <option
                                                                            value={item.toLowerCase()}>{item}</option>
                                                                    })}
                                                                </select>
                                                                <div className={'w-100'}>
                                                                <span
                                                                    className={''}>PM: {currCandidate.db_candidate_info.latest_stable_level}</span>
                                                                </div>
                                                                <AllUserInputField arrInfo={currCandidate.allCandidateCategoriesInfo} field='latest_stable_level'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}><b>Highest Level (BB)</b></label>
                                                                {excelDataValidation(currCandidate.standard_info.highest_level,
                                                                    currCandidate.db_candidate_info.highest_level, "string", LATEST_STABLE_LEVELS)}
                                                                <select
                                                                    className={`form-control ${getColorClass(currCandidate.standard_info.highest_level, currCandidate.db_candidate_info.highest_level)}`}
                                                                    value={currCandidate.highest_level.toLowerCase()}
                                                                    name={'highest_level'}
                                                                    onChange={event => onChangeInput(event)}>
                                                                    {LATEST_STABLE_LEVELS.map((item, index) => {
                                                                        return <option
                                                                            value={item.toLowerCase()}>{item}</option>
                                                                    })}
                                                                </select>
                                                                <div className={'w-100'}>
                                                                <span
                                                                    className={''}>Excel: {currCandidate.extract_result.highest_level}</span>
                                                                </div>

                                                                <div className={'w-100'}>
                                                                <span
                                                                    className={''}>PM: {currCandidate.db_candidate_info.highest_level}</span>
                                                                </div>
                                                                <AllUserInputField arrInfo={currCandidate.allCandidateCategoriesInfo} field='highest_level'/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <CandidateFlows candidate={currCandidate} onSave={() => onSaveFlows()} changeFlows={(can) => {setCurrCandidate({...can})}}/>
                                                </div>
                                                <div id='language-tab' className='tab-pane fade'>
                                                    <CandidateLanguageComponent
                                                        candidateId={currCandidate.id} mode={CandidateDetailLanguageMode.EXTRACT}
                                                        onChange={(values) => {onChangeLanguages(values)}}
                                                    />
                                                </div>
                                            </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    < div className='card-footer'>
                        <div className={'row'}>
                            <div className={'col-sm-6'}>
                                <h3 className='card-title col-sm-12'>Kết quả extract
                                    ({currentIndex + 1}/{candidates.length})</h3>
                            </div>
                            <div className={'card-tools row'}>
                                <div className={'text-right'}>
                                    {currentIndex > 0 ?
                                        <a className='btn' href='#' onClick={onCandidateBack}>
                                            <i className='fas fa-arrow-left'/> Back
                                        </a> :
                                        <button className='btn' disabled type={'button'}>
                                            <i className='fas fa-arrow-left'/> Back
                                        </button>
                                    }
                                </div>
                                <div className={'text-right'}>
                                    {currentIndex < candidates.length - 1 ?
                                        <a className='btn' href='#' onClick={onCandidateNext}>
                                            <i className='fas fa-arrow-right'/> Next
                                        </a> :
                                        <button className='btn' disabled type={'button'}>
                                            <i className='fas fa-arrow-right'/> Next
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className='modal fade' id='inputCommonModal'>
                <div className='modal-dialog modal-lg'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h4 className='modal-title'>Nhập chung</h4>
                            <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        <div className='modal-body'>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Quốc tịch</b></label>
                                <div style={{width: '100%'}}>
                                    <Select options={CANDIDATE_NATIONALITIES} isMulti
                                            value={
                                                inputCommonData.common_local_nationality && inputCommonData.common_local_nationality.length > 0 ?
                                                    inputCommonData.common_local_nationality : []}
                                            onChange={values => {
                                                onChangeCommonInput(values, 'common_local_nationality');
                                            }}
                                    />
                                </div>
                            </div>
                            <>
                                <div className='input-group mt-3'>
                                    <label className={'w-100 text-warning'}><b>UV lạ/quen</b></label>
                                    <select className='form-control'
                                            name={'candidate_know_state'}
                                            disabled={inputCommonData.candidate_know_state==='4'}
                                            value={inputCommonData.candidate_know_state}
                                            onChange={event => onChangeCommonInput(event)}>
                                        <option value='1'>N/A</option>
                                        <option value='2'>UV lạ</option>
                                        <option value='3'>UV quen chưa giới thiệu GP</option>
                                        <option value='4' disabled={!userLoginInfo.is_superuser}>UV quen đã giới thiệu GP</option>
                                    </select>
                                </div>
                                <div className='input-group mt-3'>
                                    <label className={'w-100'}><b>Đối tượng đặc biệt</b></label>
                                    <div style={{width: '100%'}}>
                                        <Select options={OBJECT_SPECIALS} isMulti
                                                value={inputCommonData.object_special}
                                                onChange={value => {
                                                    onChangeCommonInput(value, 'object_special');
                                                }}
                                        />
                                    </div>
                                </div>
                                <div className='input-group mt-3'>
                                    <label className={'w-100'}><b>Loại UV khỏi Search tiêu chuẩn</b></label>
                                    <select className='form-control'
                                            name={'standard_search_ignore'}
                                            value={inputCommonData.standard_search_ignore}
                                            onChange={event => onChangeCommonInput(event)}>
                                        <option value='1'>N/A</option>
                                        <option value='2'>Loại UV</option>
                                    </select>
                                </div>
                                {userLoginInfo.is_superuser &&
                                <>
                                    <div className='input-group mt-3'>
                                        <label className={'w-100'}><b>Nhập list ME</b></label>
                                        <select className='form-control'
                                                name={'input_me_list'}
                                                value={inputCommonData.input_me_list}
                                                onChange={event => onChangeCommonInput(event)}>
                                            {ME_LIST_INPUT.map(item => (
                                                <option value={item.value} key={`me-list-input-${item.value}`}>{item.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='input-group mt-3'>
                                        <label className={'w-100'}><b>Block UV</b></label>
                                        <select className='form-control'
                                                name={'block_state'}
                                                value={inputCommonData.block_state}
                                                onChange={event => onChangeCommonInput(event)}>
                                            <option value='1'>Unblock</option>
                                            <option value='2'>Blocked</option>
                                        </select>
                                    </div>
                                </>
                                }
                                <div className='input-group mt-3'>
                                    <label className={'w-100'}><b>Xếp loại UV</b></label>
                                    <select className='form-control'
                                            name={'candidate_type'}
                                            value={inputCommonData.candidate_type}
                                            onChange={event => onChangeCommonInput(event)}>
                                        {PersonTypeOptions.map(item => (
                                            <option value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className='input-group mt-3'>
                                    <label className={'w-100'}><b>Note (Phân luồng)</b></label>
                                    <input type='text' className='form-control'
                                           value={inputCommonData.flow_note}
                                           name={'flow_note'}
                                           onChange={event => onChangeCommonInput(event)}/>
                                </div>
                                {/*<div className='input-group mt-3'>*/}
                                {/*    <label className={'w-100'}><b>Hide/Show</b></label>*/}
                                {/*    <select className='form-control'*/}
                                {/*            name={'show_hide_state'}*/}
                                {/*            value={inputCommonData.show_hide_state}*/}
                                {/*            onChange={event => onChangeCommonInput(event)}>*/}
                                {/*        <option value='1'>Show</option>*/}
                                {/*        <option value='2'>Hide loại 1</option>*/}
                                {/*        <option value='3'>Hide loại 2</option>*/}
                                {/*    </select>*/}
                                {/*</div>*/}
                            </>
                        </div>
                        <div className='modal-footer justify-content-between'>
                            <button type='button' className='btn btn-default' data-dismiss='modal'>Close</button>
                            <button type='button' className='btn btn-primary' data-dismiss='modal'
                                    onClick={() => onSaveCommonData()}>Save changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProcessUploadExcelResult;
